export default (state = {}, {res}) => {
  return {
    ...state,
    dispositionDescription: res,
  };
};
